import { useBasicStore, useUIStore } from 'store';
import styled, { useTheme } from 'styled-components';
import { asyncStore } from '@/_helpers/base';
import { TTheme } from '@/_models/Common';
import { FAIcon } from '@packages/ui-components';

export const PathSelectModal = styled.div`
  position: absolute;
  /* bottom: 0; */
  /* width: 100%; */
  z-index: 999;
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(7.5px);
  /* border-radius: 20px 20px 0px 0px; */
  padding: 20px;
  color: white;
  font-size: 16px;
  max-height: 90vh;
  padding-top: 0;

  width: 300px;
  bottom: 200px;
  right: 50px;
  border-radius: 20px;

  animation: 1s ease 0s 1 normal forwards running alert-toast-appear;

  &.dsp-sbIsOpen {
    right: 162px;
  }

  .psm-header {
    display: flex;
    justify-content: space-between;

    align-items: center;
    margin-bottom: 3px;
  }
  .psm-closeBlock {
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .psm-item {
    display: flex;
    justify-content: space-between;
    margin-bottom: 13px;
    background: rgba(0, 0, 0, 0.18);
    border-radius: 15px;
    padding: 6px 7px;
  }
  .psm-imgWrap {
    width: 40px;
    height: 40px;
    border-radius: 9px;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    margin-right: 7px;
  }
  .psm-name {
    font-size: 14px;
  }
  .psm-next {
    margin-right: 17px;
    align-items: center;
    display: flex;
  }
  .psm-steps {
    font-size: 12px;
  }
  .psm-imgDeskWrap {
    display: flex;
  }
  i {
    font-size: 16px;
  }
`;

interface IDesktopSwitchPath {
  pathLocks: any;
  pathLockId: number;
  currentPathStepId: number;
  gameId: number;
  finishedPaths: number[];
  handleChangePath: (ev: any) => void;
}

const DesktopSwitchPath = (props: IDesktopSwitchPath) => {
  const { pathLocks, pathLockId, currentPathStepId, gameId, handleChangePath, finishedPaths } =
    props;
  const forceShowPathSwitchMobileModal = useBasicStore((state) => state.forceShowPathSwitchMobileModal);
  const setForceShowPathSwitchMobileModal = useBasicStore((state) => state.setForceShowPathSwitchMobileModal);
  const translation = useBasicStore((state) => state.translationData);
  const sbIsOpen = useUIStore((state) => state.sidebarOpen);
  const { device }: TTheme = useTheme();
  const pathSnapshot = asyncStore?.pathSnapshot;
  const handleCloseSwitchModal = () => {
    setForceShowPathSwitchMobileModal(false);
  };
  const onChangePath = (path, currentStep, stepsLength) => () => {
    const { multiPaths } = window as any;
    let data = [{ id: path.id, name: path.name, startTime: Date.now(), currentStep, stepsLength }];
    const existingPath = multiPaths?.find((multiPath) => multiPath.id === path.id);
    if (!existingPath) {
      if (multiPaths) {
        data = [...data, ...multiPaths];
      }
      // @ts-ignore
      window.multiPaths = data;
    }
    setForceShowPathSwitchMobileModal(false);
    if (handleChangePath) handleChangePath({ target: { value: path.id } });
  };
  return (
    !device?.mobile &&
    forceShowPathSwitchMobileModal && (
      <PathSelectModal className={sbIsOpen && 'dsp-sbIsOpen'}>
        <div className="psm-header">
          <div>{translation?.multipathSwitcher || 'Multipath switcher'}</div>
          <div className="psm-closeBlock" onClick={handleCloseSwitchModal}>
            <FAIcon icon="faTimes" />
          </div>
        </div>
        <div className="psm-items-wrap">
          {pathLocks?.map((p) => {
            const isFinished = finishedPaths?.includes(p.id);
            // use this if p.id = currentLock
            let currentStep;
            let stepsLength;
            if (p.id === pathLockId) {
              currentStep = (asyncStore?.pathIds || [])?.indexOf(currentPathStepId) + 1;
              stepsLength = asyncStore?.pathIds?.length;
            } else if (pathSnapshot[p.id]) {
              currentStep =
                (pathSnapshot[p.id]?.pathIds || [])?.indexOf(
                  pathSnapshot[p.id]?.currentPathStep?.id,
                ) + 1;
              stepsLength = pathSnapshot[p.id]?.pathIds?.length;
            } else {
              currentStep = 1;
              stepsLength = p?.paths?.length;
            }
            // if not, we need to check is it exists on pathSnapshot
            // if yes - get data from there
            // if no - cound steps and set 0 / length
            return (
              <div
                className="psm-item"
                onClick={isFinished ? undefined : onChangePath(p, currentStep, stepsLength)}
                key={p?.id}
              >
                <div className="psm-imgDeskWrap">
                  <div
                    className="psm-imgWrap"
                    style={{
                      backgroundImage: `url(${`${process.env.NEXT_PUBLIC_CDN}/games/${gameId}/locks/${p.id}/${p.pathSetting?.icon}`})`,
                    }}
                  />
                  <div className="psm-deskWrap">
                    <div className="psm-name">{p.name}</div>
                    {isFinished ? (
                      <div className="psm-steps">{translation.finished || 'finished'}</div>
                    ) : (
                      <div className="psm-steps">
                        {currentStep}/{stepsLength}{' '}
                        {translation.stepsCompleted || 'steps completed'}
                      </div>
                    )}
                  </div>
                </div>
                <div className="psm-next">
                  <FAIcon icon="faArrowRight" />
                </div>
              </div>
            );
          })}
        </div>
      </PathSelectModal>
    )
  );
};

export default DesktopSwitchPath;
